import { render, staticRenderFns } from "./ListGemeenten.vue?vue&type=template&id=1937b730&"
import script from "./ListGemeenten.vue?vue&type=script&lang=js&"
export * from "./ListGemeenten.vue?vue&type=script&lang=js&"
import style0 from "./ListGemeenten.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListGemeenten.vue"
export default component.exports